module.exports = __webpack_public_path__ + "img/icon-turn-right.d303b89d.svg";